var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['cm-language-switch', { 'language-switch--open': _vm.isOpen }]},[_c('hot-hcm-dropdown',{ref:"dropdownRef",attrs:{"dropdown-class":"_d-block","on-close":_vm.close,"on-open":_vm.open},scopedSlots:_vm._u([{key:"button",fn:function(){return [_c('button',{class:[
          'hot-button',
          'hot-dropdown__toggle',
          '_w-full',
          '_bg-brand-primary-lightest',
          '_border-brand-primary-lightest',
          '_text-brand-primary-dark',
          '_text-left',
          '_pl-3',
          '_pr-5',
          '_py-2',
        ],attrs:{"slot":"button"},slot:"button"},[_c('hot-hcm-dropdown-header',{attrs:{"dropdown-header-class":[
            '_px-0',
            '_py-0',
            '_w-full',
            '_text-left',
            '_text-brand-primary-dark',
          ]}},[_vm._v("\n          "+_vm._s(_vm.localeTitle)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"_d-flex _justify-content-between"},[_c('span',[_vm._v(_vm._s(_vm.currentLocale.name))]),_vm._v(" "),_c('hot-hcm-icon',{attrs:{"font-awesome":['fas', 'angle-down'],"icon-class":_vm.getIconClass()}})],1)],1)]},proxy:true},{key:"menu",fn:function(){return _vm._l((_vm.locales),function(locale,i){return _c('hot-hcm-dropdown-item',{key:i,attrs:{"select":_vm.select,"name":locale.code}},[_c('a',{staticClass:"dropdown-item-link",attrs:{"href":locale.href,"rel":"alternate","hreflang":locale.code,"data-test-btn":"LanguageSwitchLink"}},[_vm._v("\n          "+_vm._s(locale.name)+"\n        ")])])})},proxy:true}])}),_vm._v(" "),_c('transition',{attrs:{"name":"language-switch__overlay"}},[(_vm.isOpen)?_c('div',{staticClass:"language-switch__overlay"}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }